module.exports = __webpack_public_path__ + "static/transient_recorders.0805c2b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/category/transient_recorders.png
// module id = 706
// module chunks = 229884840450167